// extracted by mini-css-extract-plugin
module.exports = {"promptBack":"StayOnPagePrompt_promptBack__3dZZ3"};